import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const WellFargoTransactionSchema = z.object({
    fileIngestionId: z.number(),
    lockboxNum: z.number().nullable(),
    lockboxDate: z.date().nullable(),
    batchNum: z.number().nullable(),
    itemNum: z.number().nullable(),
    checkRemitterName: z.string().nullable(),
    checkNum: z.number().nullable(),
    remittanceAmount: z.number().nullable(),
    isInVelocity: z.boolean().nullable(),
    invoiceNumber: z.string().nullable(),
    checkAmount: z.number().nullable(),
    inBalance: z.boolean(),
    velocityInvoiceAmount: z.number().nullable(),
    policyNum: z.string().nullable(),
    minimumEarnedPremium: z.boolean().nullable(),
    largeOverPayment: z.boolean().nullable(),
    invoiceInBalance: z.boolean().nullable(),
});

export type WellsFargoTransaction = z.infer<typeof WellFargoTransactionSchema>;

export const all = async (
    fileIngestionId: number,
    pagination: PaginationState,
    sorting: SortingState = [],
    params: object,
): Promise<{ data: WellsFargoTransaction[]; total: number }> => {
    try {
        let queryString = '';
        if (params) {
            const paramsAsString = JSON.stringify(params)
                .replace(/:/g, '=')
                .replace(/,/g, '&')
                .replace(/[{}"]/g, '');

            const searchParams = new URLSearchParams(paramsAsString);
            if (pagination) {
                searchParams.append('pageSize', pagination.pageSize.toString());
                searchParams.append('pageIndex', pagination.pageIndex.toString());
            }
            
            if (sorting.length > 0) {
                searchParams.append('sortBy', sorting[0].id);
                searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
            }

            queryString = `?${searchParams.toString()}`;
        }

        const response = await fetch(`/WellsFargo/wells-fargo-transactions/${fileIngestionId}${queryString}`);

        return await response.json();
    } catch (err) {
        return {
            data: [],
            total: 0,
        };
    }
};

export const downloadPolicies = async (
    fileIngestionId: number,
): Promise<Blob> => {
    const response = await fetch(
        `/GeoveraTransactions/download/${fileIngestionId}`,
        {
            method: 'GET',
        },
    );

    return await response.blob();
};
